import DeliveredIconSvg from './delivered-icon.svg';
import IngredientsIconSvg from './ingredients-icon.svg';
import SaucepanIconSvg from './saucepan-icon.svg';
import StethoscopeIconSvg from './stethoscope-icon.svg';

export {
  DeliveredIconSvg,
  IngredientsIconSvg,
  SaucepanIconSvg,
  StethoscopeIconSvg,
};
